var _path, _path2, _path3, _path4, _path5, _path6;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBfidCertified(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 37,
    viewBox: "0 0 36 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.5498 10.1833V14.325C19.5498 15.8417 19.5498 15.8417 20.9831 16.8083L24.9248 19.0833C25.5165 19.425 26.4831 19.425 27.0748 19.0833L31.0165 16.8083C32.4498 15.8417 32.4498 15.8417 32.4498 14.325V10.1833C32.4498 8.66668 32.4498 8.66668 31.0165 7.70001L27.0748 5.42501C26.4831 5.08335 25.5165 5.08335 24.9248 5.42501L20.9831 7.70001C19.5498 8.66668 19.5498 8.66668 19.5498 10.1833Z",
    stroke: "#CACACA",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M30.5832 7.35832V5.16666C30.5832 3.49999 29.7498 2.66666 28.0832 2.66666H23.9165C22.2498 2.66666 21.4165 3.49999 21.4165 5.16666V7.29999",
    stroke: "#CACACA",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M26.525 10.1583L27 10.9C27.075 11.0167 27.2416 11.1333 27.3666 11.1667L28.2166 11.3833C28.7416 11.5167 28.8833 11.9667 28.5416 12.3833L27.9833 13.0583C27.9 13.1667 27.8333 13.3583 27.8416 13.4917L27.8916 14.3667C27.925 14.9083 27.5416 15.1833 27.0416 14.9833L26.225 14.6583C26.1 14.6083 25.8916 14.6083 25.7666 14.6583L24.95 14.9833C24.45 15.1833 24.0666 14.9 24.1 14.3667L24.15 13.4917C24.1583 13.3583 24.0916 13.1583 24.0083 13.0583L23.45 12.3833C23.1083 11.9667 23.25 11.5167 23.775 11.3833L24.625 11.1667C24.7583 11.1333 24.925 11.0083 24.9916 10.9L25.4666 10.1583C25.7666 9.70833 26.2333 9.70833 26.525 10.1583Z",
    stroke: "#CACACA",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M33 20V22.9999C33 30.4999 30 33.4999 22.5 33.4999H13.5C6 33.4999 3 30.4999 3 22.9999V13.9999C3 6.49991 6 3.49991 13.5 3.49991H17.0001",
    stroke: "#CACACA",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M9 22.5H18",
    stroke: "#CACACA",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M9 25.5H15",
    stroke: "#CACACA",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBfidCertified);
export default __webpack_public_path__ + "static/media/bfid-certified.f1d21ce6b3201a74f170c4aacfdfd632.svg";
export { ForwardRef as ReactComponent };